import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { FunctionService } from 'vhobjects-service/src/services';


@Component({
  selector: 'atw-date-delivery-config',
  templateUrl: './date-delivery-config.component.html',
  styleUrls: ['./date-delivery-config.component.scss']
})
export class AtwDateDeliveryConfig implements OnInit {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any; // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
  ];

  fonts = [];
  dataAfterChange: any = {};
  arr_link_page: any;
  id_subproject: any = '';
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public functionService: FunctionService,
    private vhEventMediator: VhEventMediator,
  ) {}

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
    ]).subscribe(([fonts]: any) => {
      this.fonts = fonts;
    });
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool) => {
      });
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['text']['width'] = event.width + 'px';
    if (event.height) this.class['text']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            if (
              this.functionService.selectedLanguageCode != lang.code 
              && !this.staticdata[`${fieldContent}_${lang.code}`]
            ) {
              this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                item => item.langCode == lang.code
              ).translatedText;
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
